import { render, staticRenderFns } from "./AffectUserToAgencyButton.vue?vue&type=template&id=010ceac8&"
import script from "./AffectUserToAgencyButton.vue?vue&type=script&lang=js&"
export * from "./AffectUserToAgencyButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports